export default "/static/images/build_roof_8.png?a9384d5f0aa0c865a7137b71422b538a";